import { createGlobalStyle } from 'styled-components'

const CustomStyles = createGlobalStyle`
  html, body {
    min-height: 100%;
  }
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Montserrat', sans-serif;
    background-color: var(--color-accentroWhite-full, #ffffff);
    color: var(--color-accentroGray-full, #2b2d36);
    overflow-x: hidden;
  }
`

// Inject Montserrat font faces dynamically (legacy pattern preserved)
if (typeof document !== 'undefined') {
  const existing = document.getElementById('global-font-montserrat')
  if (!existing) {
    const fontStyle = document.createElement('style')
    fontStyle.id = 'global-font-montserrat'
    fontStyle.textContent = `
  @font-face {
    font-family: 'Montserrat';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/Montserrat-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: 'Montserrat';
    font-weight: 600;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/Montserrat-SemiBold.ttf') format('truetype');
  }
`
    document.head.appendChild(fontStyle)
  }
}

export const GlobalStyles = () => <CustomStyles />
